import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import i18n from '../../services/i18n';
import './InfoModal.scss';

const InfoModal = ({
  isOpen,
  onClose,
  content,
  info,
  onSubmit,
  loading,
  onDelete,
  notificationType = null,
  notificationMessage = null
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    return () => document.body.classList.remove('modal-open');
  }, [isOpen, notificationType, onClose]);

  const getIcon = () => {
    if (notificationType === 'success') {
      return '/assets/images/new-desing/icon-success.svg';
    } else if (notificationType === 'error') {
      return '/assets/images/new-desing/icon-error.svg';
    } else {
      return onSubmit || info || loading
        ? '/assets/images/new-desing/icon-info.svg'
        : '/assets/images/new-desing/icon-success.svg';
    }
  };

  const getIconClass = () => {
    if (notificationType === 'success') {
      return 'modal-icon-success';
    } else if (notificationType === 'error') {
      return 'modal-icon-error';
    } else {
      return onSubmit || info || loading
        ? 'modal-icon-info'
        : 'modal-icon-success';
    }
  };

  const createMarkup = htmlContent => ({ __html: htmlContent });

  if (!isOpen) {
    return null;
  }

  const displayContent = notificationMessage || content;

  return createPortal(
    <div className={'modal-container'}>
      <div className={'modal-overlay'} />
      <div
        className={'modal-content'}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <div className={'modal-header'}>
          <div className={`modal-icon-seccion ${getIconClass()}`}>
            <img
              src={getIcon()}
              alt={`icon-${notificationType || 'info'}`}
              width={28}
            />
          </div>
        </div>
        <div className={'modal-body'}>
          <div className={'reminder-content'}>
            <p
              style={{
                margin: '0',
                color: '#000'
              }}
              dangerouslySetInnerHTML={createMarkup(displayContent)}
            />
          </div>
        </div>
        {!loading && (
          <div className={'modal-footer'}>
            {onSubmit && !notificationType ? (
              <>
                <button
                  onClick={onClose}
                  className={`modal-button modal-cancel-button`}
                >
                  {i18n.t('info-modal.cancel')}
                </button>
                <button
                  onClick={onSubmit}
                  className={`modal-button modal-send-button`}
                >
                  {onDelete
                    ? i18n.t('info-modal.delete')
                    : i18n.t('info-modal.accept')}
                </button>
              </>
            ) : (
              <button
                onClick={onClose}
                className={`modal-button modal-send-button`}
              >
                {i18n.t('info-modal.accept')}
              </button>
            )}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default InfoModal;
